import { makeObservable } from 'mobx'
import { Slide } from './Slide'
import { sortQuestions } from '../../../sources-of-truth/sortQuestions'

export class InteractivePollSlide extends Slide {
  afterConstructor() {
    makeObservable(this, {
      questions: true,
    })
  }

  get questions() {
    const pollsForSlide = this.meeting.questions.filter(
      (q) => q.slideId === this.meeting.currentSlide?.id && q.isPoll
    )

    return sortQuestions({ questions: pollsForSlide, slideIds: [] })
  }

  get titleIndex(): number {
    // loop over currentSlide.questions and find out if all are submitted
    for (const q of this.questions) {
      if (!q.isSubmitted) {
        return 0
      }
    }
    return 1
  }
}
